import { useMemo } from 'react';
import GeckoRequest from '../../../../services/gecko-request';
import { v4 as uuidv4 } from 'uuid';

export const FieldMappingFactory = () => {
  const createField = async (attribute) => {
    let endpoint = '/fields';
    const account = await GeckoRequest.get('/account');
    const builtField = {
      account_id: account.id,
      custom_field: true,
      editor_object: {},
      field_options:
        attribute.options !== ''
          ? attribute.options.split('\n').map((opt) => {
              let [label, value] = opt.split('|');
              if (!value) value = label;
              return {
                label: label.trim(),
                value: value.trim(),
                id: uuidv4(),
              };
            })
          : [],
      key: attribute.key,
      label: attribute.label,
      raw_options: '',
      required_for_sync: false,
      type: attribute.type,
      single_entry_mode: {},
    };

    return await GeckoRequest.post(endpoint, builtField);
  };

  return {
    createField,
  };
};

export const useFieldMapping = () => {
  return useMemo(() => {
    return FieldMappingFactory();
  }, []);
};
